import { render } from "./ArrowChart.vue?vue&type=template&id=577b5cd7&scoped=true"
import script from "./ArrowChart.vue?vue&type=script&lang=js"
export * from "./ArrowChart.vue?vue&type=script&lang=js"

import "./ArrowChart.vue?vue&type=style&index=0&id=577b5cd7&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577b5cd7"]])

export default __exports__